export type { LemonDividerProps } from './LemonDivider'
export { LemonDivider } from './LemonDivider'
